<template>
    <div class="el-table-container">
        <div class="query-form">
            <el-tabs v-model="activeName" size="small">
                <el-tab-pane label="系统操作日志" name="2"></el-tab-pane>
            </el-tabs>
        </div>
        <SysLog v-if="activeName == 2"></SysLog>
    </div>
</template>

<script>
    import SysLog from './sysLog'
    export default {
        components: {SysLog},
        data() {
            return {
                activeName: '2'
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
</style>
